import analytics from './../utils/segmentUtils'

export const logger = store => next => action => {
    let result = next(action)
    if (action.type !== 'UPDATE_TIME_LEFT' && action.type !== 'ADD_SHOW_MAIL_FLAG') {
        // console.log('dispatching', action, store.getState())
        analytics.track(action.type, action.payload)
    }
    // console.log('next state', store.getState())
    return result
}



// WEBPACK FOOTER //
// /src/middlewares/segmentMiddleware.js